<template>
  <div class="d-flex flex-column justify-content-center align-items-center col-md-11 router-view-background">
    <div class="col-md-12 mb-10">
      <the-filters
        :filters="computedFilters"
        @get-model="getFiltersModel"
      />
    </div>
    <div class="col-md-12">
      <the-table 
        :key="tableKey"
        :dataItems="computedFarms"
        :headers="headersForTable"
      >
        <template v-slot:actions="{item}">
          <b-dropdown right id="dropdown-menu-table" text="Menu" variant="menu-table" class="m-2 p-0 menu-table">           
            <b-dropdown-item
              class="pr-5 pl-5 b-drop-options"
              variant="text"
              @click="editFarm(item)"
            >
              <i class="mdi mdi-pencil pr-5"></i> Editar Propriedade
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </the-table>
    </div>
    <float-button
      icon="mdi mdi-plus"
      :class="filters.creator ? '' : 'disable-button'"
      @event="openSidebar"
    />
    <sidebar-farm
      :creators="creators"
      :partners="partners"
      :farmEdit="farmToEdit"
      @close="
        farmToEdit = {};
        SET_ACTIVE(false);
        getFiltersModel({title:'creator', value:filters.creator});
      "
    />
  </div>
</template>

<script>
import TheTable from "@/components/layout/TheTable";
import FloatButton from "@/components/layout/ButtonFloat";
import TheFilters from "@/components/layout/TheFilters";
import SidebarFarm from "./SidebarFarms";
import {BDropdown, BDropdownItem} from "bootstrap-vue";
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  name: "FarmsList",
  components: {
    TheTable,
    FloatButton,
    TheFilters,
    BDropdown,
    BDropdownItem,
    SidebarFarm
  },
  data() {
    return {
      tableKey:0,
      headersForTable:[
        {text:"Nome", value:"name"},
        {text:"Cod. Integração", value:"code_integration"},
        {text:"", value:"actions", has_slot:true}
      ],
      farmToEdit:{},
      filters: {},
      showFarms: false
    }
  },
  computed: {
    ...mapState("farms", [
      "farms"
    ]),
    ...mapState("creators", [
      "creators"
    ]),
    ...mapState("creators", [
      "creators"
    ]),
    ...mapState("partners", [
      "partners"
    ]),
    computedFarms() {
      if(this.showFarms) {
        return this.farms;
      } else {
        return [];
      }
    },
    computedFilters() {
      return [
        {name:"creator", type:"select", label:"Criador", items:this.creators},
      ]
    }
  },
  methods: {
    ...mapActions("farms", [
      "actionGetFarms"
    ]),
    ...mapActions("creators", [
      "actionGetCreators"
    ]),
    ...mapActions("partners", [
      "actionGetPartners"
    ]),
    ...mapMutations("sidebar", [
      "SET_ACTIVE"
    ]),
    async getFiltersModel(filters) {
      if(filters.title === "creator") {
        this.filters.creator = filters.value;
        await this.actionGetFarms(filters.value);
        this.showFarms = true;
      }
    },
    editFarm(farm) {
      this.farmToEdit = farm;
      this.SET_ACTIVE(true);
    },
    openSidebar() {
      this.farmToEdit = {};
      this.SET_ACTIVE(true);
    }
  },
  async mounted() {
    await this.actionGetCreators();
    await this.actionGetPartners();
  }
}
</script>

<style scoped>
.b-drop-options {
  cursor: pointer;
}
.disable-button {
  opacity: 0.5;
  pointer-events: none;
}
</style>